import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { AppointmentRequest } from '../../../models/appointment-request';

import { AlertService } from '../../../services/common/alert.service';
import { AddressService } from '../../../services/contacts/address.service';
import { AppointmentRequestService } from '../../../services/appointment_requests/appointment-request.service';

@Component({
  selector: 'app-appointment-request-form',
  templateUrl: './appointment-request-form.component.html',
  styleUrls: ['./appointment-request-form.component.css'],
})
export class AppointmentRequestFormComponent implements OnInit {
  appointmentRequest: any;
  attendees: Array<any>;
  locations: Array<any>;
  selectedAttendees: Array<any>;
  selectedAttendee: any;
  matter: any;
  contact_id: number;
  errors: string;
  formSubmitted: boolean;
  formSubmitting: boolean;
  formOptions: any = {
    event_types: [],
    lengths: [],
    how_soon: [],
  };

  constructor(private router: Router, private alertService: AlertService, private addressService: AddressService, private appointmentRequestService: AppointmentRequestService, private route: ActivatedRoute) {
    this.appointmentRequest = new AppointmentRequest();
    this.selectedAttendees = [];
    this.appointmentRequestService.getFormOptions().then((response_json) => {
      this.formOptions = response_json;
      if (this.formOptions.event_types) this.formOptions.event_types = [{}].concat(this.formOptions.event_types);
      if (this.formOptions.lengths) this.formOptions.lengths = [{}].concat(this.formOptions.lengths);
      if (this.formOptions.how_soon) this.formOptions.how_soon = [{}].concat(this.formOptions.how_soon);
    });
    this.formSubmitted = false;
    this.formSubmitting = false;
  }

  ngOnInit() {
    if (this.route.snapshot.params['id'])
      this.appointmentRequestService.getEditAppointmentRequest(this.route.snapshot.params['id']).then((response_json) => {
        if (response_json) {
          this.appointmentRequest = response_json.appointment_request;
          this.selectedAttendees = response_json.appointment_request_attendees;
          this.matter = response_json.matter;
          this.attendees = response_json.attendees;
          if (response_json.location && !response_json.location.highlight) this.onLocationContactSelect(response_json.location.contact_id);
          this.onEventTypeChange();
          this.onMatterSelect(this.matter.appointmentRequest.matter_id);
        }
      });
    else if (this.route.snapshot.params['matter_id']) this.appointmentRequest.matter_id = Number(this.route.snapshot.params['matter_id']);
  }

  onMatterSelect(matter_id: number) {
    this.appointmentRequest.matter_id = matter_id;
    this.appointmentRequestService.getAttendees(matter_id).then((response_json) => {
      this.attendees = [{}].concat(response_json.attendees);
      this.selectedAttendees = response_json.clients;
      this.matter = response_json.matter;
    });
  }

  addAttendee() {
    var selectedAttendees = this.selectedAttendees;
    if (this.selectedAttendee) {
      var selectedAttendee = this.selectedAttendee;
      for (var i in selectedAttendees)
        if (selectedAttendees[i].value == selectedAttendee.value) {
          this.selectedAttendee = null;
          return;
        }
      selectedAttendees.push(selectedAttendee);
      this.selectedAttendee = null;
    }
  }

  removeAttendee(attendee: any) {
    var attendee_index = this.selectedAttendees.indexOf(attendee);
    this.selectedAttendees.splice(attendee_index, 1);
  }

  onLocationContactSelect(contact_id: number) {
    this.contact_id = contact_id;
    this.addressService
      .getAddresses({
        contact_id: contact_id,
        get_simple_addresses: true,
      })
      .then((response_json) => (this.locations = [{}].concat(response_json)));
  }

  submitForm(formValid: boolean) {
    this.formSubmitted = true;
    if (formValid && this.additionalValidations()) {
      this.formSubmitting = true;
      if (this.appointmentRequest.id)
        this.appointmentRequestService
          .updateAppointmentRequest(this.appointmentRequest.id, {
            appointment_request: this.appointmentRequest,
            appointment_request_attendees: this.getSelectedAttendees(),
          })
          .then((response_json) => {
            this.formSubmitting = false;
            if (response_json && response_json.text) this.router.navigate(['/appointment_requests']);
            else this.alertService.alert_status_danger('Error updating appointment request');
          })
          .catch(() => {
            this.alertService.alert_status_danger('Error updating appointment request');
          });
      else
        this.appointmentRequestService
          .createAppointmentRequest({
            appointment_request: this.appointmentRequest,
            appointment_request_attendees: this.getSelectedAttendees(),
          })
          .then((response_json) => {
            this.formSubmitting = false;
            if (response_json && response_json.text) this.router.navigate(['/appointment_requests']);
            else this.alertService.alert_status_danger('Error creating appointment request');
          })
          .catch(() => {
            this.alertService.alert_status_danger('Error creating appointment request');
          });
    }
  }

  additionalValidations(): boolean {
    if (this.selectedAttendees.length < 1) return false;
    else return true;
  }

  getSelectedAttendees() {
    var attendees = [];
    for (var i in this.selectedAttendees) {
      attendees.push({
        contact_id: this.selectedAttendees[i].value,
      });
    }
    return attendees;
  }

  fieldShowErrorMessage(field: any) {
    if (!field.valid && this.formSubmitted) return true;
    else return false;
  }

  onEventTypeChange() {
    for (var i in this.formOptions.event_types)
      if (this.formOptions.event_types[i].label == 'Phone Conference' && this.formOptions.event_types[i].value == this.appointmentRequest.event_type_id) {
        this.formOptions.eventTypePhone = true;
        this.locations = [];
        this.appointmentRequest.location_id = null;
        return;
      }
    this.formOptions.eventTypePhone = false;
  }
}
